module.exports = __webpack_public_path__ + "static/media/Offices-3.c4381441.webp";